// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul.styles-module__menu___WxPP0{min-width:140px;border-radius:0;padding:5px 0}`, "",{"version":3,"sources":["webpack://./src/components/ThreeDotsMenu/Components/DefaultMenu/styles.module.scss"],"names":[],"mappings":"AAAA,+BACE,eAAA,CACA,eAAA,CACA,aAAA","sourcesContent":["ul.menu {\r\n  min-width: 140px;\r\n  border-radius: 0;\r\n  padding: 5px 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var menu = `styles-module__menu___WxPP0`;
export default ___CSS_LOADER_EXPORT___;
